
const reviews_swiperrea = new Swiper('.review_slides-initializere', {
  // If we need pagination
  pagination: {
    el: '.review_slides-initializere .swiper-pagination',
    clickable: true
  },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    loop: true,
    allowTouchMove: true,
  centeredSlides: true,
  slidesPerView: 5,
  breakpoints: {
    0: {
      slidesPerView: 1.25,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
      }
    },
    540: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    992: {
      slidesPerView: 5,
      spaceBetween: 30,
      freeMode: true
    }
  }
});